var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _circle, _path8, _path9, _circle2, _circle3, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinorAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020",
    gradientUnits: "userSpaceOnUse",
    x1: -2105.018,
    y1: -13.591,
    x2: -2104.018,
    y2: -13.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M165.49 139.152V80.83M32.427 138.849V80.83M42.59 27.39h59.935v37.07H42.59zM68.568 65.462v8.625M76.508 65.231v8.625"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020",
    gradientUnits: "userSpaceOnUse",
    x1: 51.973,
    y1: 45.76,
    x2: 69.818,
    y2: 45.76
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M53.223 59.208l15.345-26.897"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020",
    gradientUnits: "userSpaceOnUse",
    x1: 55.058,
    y1: 36.423,
    x2: 62.733,
    y2: 36.423
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M56.308 40.536l5.175-8.225"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020",
    gradientUnits: "userSpaceOnUse",
    x1: 59.058,
    y1: 55.095,
    x2: 66.733,
    y2: 55.095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M60.308 59.208l5.175-8.225"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020",
    gradientUnits: "userSpaceOnUse",
    x1: 27.345,
    y1: 77.109,
    x2: 171.081,
    y2: 77.109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M28.595 74.626h141.236v4.965H28.595z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020",
    gradientUnits: "userSpaceOnUse",
    x1: 112.929,
    y1: 102.446,
    x2: 154.098,
    y2: 102.446
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M114.179 102.446h38.669"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020",
    gradientUnits: "userSpaceOnUse",
    x1: 113.233,
    y1: 119.252,
    x2: 154.098,
    y2: 119.252
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_aca447ab66ff5f181daf6fcbf617a309f32e9d533515b6f7633d95731b8f0020)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M114.483 119.252h38.365"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 134.173,
    cy: 93.87,
    r: 2.715
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M109.164 86.227h49.057"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main_x0020_40",
    d: "M114.179 135.467v3.464M153.39 135.467v3.464"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 134.173,
    cy: 111.021,
    r: 2.715
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 134.275,
    cy: 127.482,
    r: 2.715
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M114.179 86.227h39.211v49.087h-39.211z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinorAsset);
export default __webpack_public_path__ + "static/media/minorAsset.7ef3edb67691233efe9ae93defabfa0a.svg";
export { ForwardRef as ReactComponent };